import { render, staticRenderFns } from "./TwoFactorChallenge.vue?vue&type=template&id=a569b41e&scoped=true"
import script from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
export * from "./TwoFactorChallenge.vue?vue&type=script&lang=js"
import style0 from "./TwoFactorChallenge.vue?vue&type=style&index=0&id=a569b41e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a569b41e",
  null
  
)

export default component.exports